import { useAuth } from '@auth/useAuth'
import { Adornment, listTenantMemberAdornments } from '@kudos/http-client'
import { useQuery } from '@tanstack/react-query'
import { format } from 'date-fns'

export const MEMBER_ADORNMENTS_QK = 'tenantMemberAdornments'

const useMemberAdornments = (memberId: string | undefined | null): Adornment | null => {
  const { tenantId } = useAuth()
  const day = format(new Date(), 'yyyy-MM-dd')

  const { data } = useQuery({
    // tenantId prevents serving another tenant's adornments after a same-session switch
    queryKey: [MEMBER_ADORNMENTS_QK, tenantId, day],
    queryFn: () => listTenantMemberAdornments({ day }),
    staleTime: 1000 * 60 * 15, // 15 min — matches backend cache TTL
    enabled: !!memberId,
  })

  if (!memberId) return null
  const adornment = data?.[memberId] ?? null
  return adornment
}

export default useMemberAdornments
